import {CustomerDocument} from '../../interfaces/customer-documents/customer-document';
import {CustomerDocumentType} from '../../interfaces/customer-documents/customer-document-type';
import {CustomerDocumentTypeFactory} from './customer-document-type-factory';
import {TkFile} from '../../interfaces/core/tk-file';
import {TkFileFactory} from '../core/tk-file-factory';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {CustomerDocumentOrigin} from '../../enums/customer-documents/customer-document-origin.enum';
import {CustomerDocumentStatus} from '../../enums/customer-documents/customer-document-status.enum';

export class CustomerDocumentFactory {

  /**
   *
   * @param customerDocument
   */
  public static fromObject(customerDocument: any): CustomerDocument {
    const customerDocumentType = customerDocument.cdo_document_type ?? customerDocument.customerDocumentType;
    const rejectEmployee = customerDocument.reject_employee ?? customerDocument.rejectEmployee;

    return new class implements CustomerDocument {
      comment: string = customerDocument.comment;
      customerDocumentType: CustomerDocumentType =
        customerDocumentType ? CustomerDocumentTypeFactory.fromObject(customerDocumentType) : null;
      customerDocumentTypeId: number =
        customerDocument.cdo_document_type_id ?? customerDocument.customerDocumentTypeId;
      date: string = customerDocument.date;
      file: TkFile = customerDocument.file ? TkFileFactory.fromObject(customerDocument.file) : null;
      customer: LightCustomer = LightCustomerFactory.fromObject(customerDocument.customer);
      customerId: number = customerDocument.customer_id ?? customerDocument.customerId;
      origin: CustomerDocumentOrigin = customerDocument.origin ?? CustomerDocumentOrigin.Local;
      status: CustomerDocumentStatus = customerDocument.status ?? null;
      rejectComment: string = customerDocument.reject_comment ?? customerDocument.rejectComment ?? null;
      rejectEmployee: LightEmployee = rejectEmployee ? LightEmployeeFactory.fromObject(rejectEmployee) : null;
      hasUnsyncedFile: boolean = customerDocument.hasUnsyncedFile ?? false;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = customerDocument.id;
      uuid: string = customerDocument.uuid;
      modified: string = customerDocument.modified;
      created: string = customerDocument.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param customerDocuments
   */
  public static fromArray(customerDocuments: any[]): CustomerDocument[] {
    return customerDocuments.map(customerDocument => this.fromObject(customerDocument));
  }

  public static toRemote(customerDocument: CustomerDocument): any {
    return {
      comment: customerDocument.comment,
      cdo_document_type_id: customerDocument.customerDocumentTypeId,
      date: customerDocument.date,
      customer_id: customerDocument.customerId,
      modified: customerDocument.modified,
      created: customerDocument.created
    };
  }

}
